export default "__VITE_ASSET__DpMytQPh__"